import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var InboxSVG = function InboxSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.84,17.62,24.52,5.21A2,2,0,0,0,22.68,4H9.32A2,2,0,0,0,7.48,5.21L2.16,17.62a1.92,1.92,0,0,0-.16.79V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V18.41A1.92,1.92,0,0,0,29.84,17.62ZM25,20H23.41l-1.56,1.57a1.49,1.49,0,0,1-1.06.43H11.21a1.49,1.49,0,0,1-1.06-.43L8.59,20H7a1,1,0,0,1,0-2H8.79a1.5,1.5,0,0,1,1.06.44L11.41,20h9.18l1.56-1.56A1.5,1.5,0,0,1,23.21,18H25a1,1,0,0,1,0,2Z"
  }));
};
InboxSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(InboxSVG);